export default __webpack_public_path__ + "static/media/logoCripto.fff4b828.png";